import { Button, IconOrganizationFilled24, IconPlus } from '@gmg/gmg-react-components';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../AppContext';
import AddOrEditOrgModalContainer from './AddOrEditOrgModalContainer';


export interface AddOrganizationBtnProps {
    existingOrgNames: string[] | undefined;
};

const AddOrganizationBtn: FC<AddOrganizationBtnProps> = (props) => {
    const { t } = useTranslation();
    const context = useContext(AppContext);

    const handleAddOrganizationBtnClick = () => {
        context.onShowModal('inputModal', {
            title: t('AddOrganizationBtn.button_title', 'Add Organization'),
            titleIcon: <IconOrganizationFilled24 />,
            content: <AddOrEditOrgModalContainer existingOrgNames={props.existingOrgNames} />,
        });
    };
    return (
        <Button
            variant="primary"
            icon={<IconPlus />}
            onClick={handleAddOrganizationBtnClick}
            disabled={!props.existingOrgNames}
        >
            {t('AddOrganizationBtn.button_title', 'Add Organization')}
        </Button>
    );
};

export default AddOrganizationBtn;